import type { ComputedRef } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { computed, reactive } from 'vue';

export function useScreenSize() {
	const { width } = useWindowSize();

	const screenSize = reactive<ScreenSize>({
		'xs': computed(() => width.value > 425),
		'sm': computed(() => width.value > 575),
		'md': computed(() => width.value > 767),
		'lg': computed(() => width.value > 991),
		'xl': computed(() => width.value > 1199),
		'2xl': computed(() => width.value > 1499),
		'3xl': computed(() => width.value > 1699),
	});

	return screenSize;
}

export interface ScreenSize {
	/**
	 * Extra small devices (phones, 600px and down)
	 */
	'xs': ComputedRef<boolean>;
	/**
	 * Small devices (tablets, 600px and up)
	 */
	'sm': ComputedRef<boolean>;
	/**
	 * Medium devices (desktops, 768px and up)
	 */
	'md': ComputedRef<boolean>;
	/**
	 * Large devices (large desktops, 992px and up)
	 */
	'lg': ComputedRef<boolean>;
	/**
	 * Extra large devices (large desktops, 1200px and up)
	 */
	'xl': ComputedRef<boolean>;
	/**
	 * Extra extra large devices (large desktops, 1500px and up)
	 */
	'2xl': ComputedRef<boolean>;
	/**
	 * Extra extra extra large devices (large desktops, 1700px and up)
	 */
	'3xl': ComputedRef<boolean>;
}
